import React, { memo, useCallback } from 'react';
import css from './ShippingDetailsForm.module.css';
import { Button, NamedLink } from '../../../components';

const TutulistOptionBlock = ({
  intl,
  defaultWeightValues,
  setDefaultWeightValues,
  saveWeightInProgress,
  onSaveDefaultToAllListings,
  weightOptions,
  showSetDefaultWeight,
  defaultWeightLabelMessage,
  defaultWeightRequiredMessage,
  isShippingDetailsPage,
}) => {
  // If the page is not shipping details, don't render anything
  if (!isShippingDetailsPage) return null;

  // Pre-compute all static texts to avoid repeated function calls in JSX
  const missingWeightText = intl.formatMessage({ id: 'ShippingDetailsForm.missingWeight' });
  const setDefaultWeightText = intl.formatMessage({ id: 'ShippingDetailsForm.setDefaultWeight' });
  const saveButtonText = intl.formatMessage({ id: 'ShippingDetailsForm.saveButton' });
  const orText = intl.formatMessage({ id: 'ShippingDetailsForm.or' });
  const updateManuallyText = intl.formatMessage({ id: 'ShippingDetailsForm.updateManually' });
  const hereLinkText = intl.formatMessage({ id: 'ShippingDetailsForm.hereLink' });

  // Use useCallback to memoize the onChange handler to avoid re-creating it on each render
  const handleWeightChange = useCallback(
    e => {
      setDefaultWeightValues({
        ...defaultWeightValues,
        weight: e.target.value,
      });
    },
    [defaultWeightValues, setDefaultWeightValues]
  );

  const handleUnitChange = useCallback(
    e => {
      setDefaultWeightValues({
        ...defaultWeightValues,
        massUnit: e.target.value,
      });
    },
    [defaultWeightValues, setDefaultWeightValues]
  );

  return (
    <div className={css.tutulistOptionBlock}>
      <p>{missingWeightText}</p>
      <p>{setDefaultWeightText}</p>

      {showSetDefaultWeight && (
        <>
          <label htmlFor="defaultWeight">{defaultWeightLabelMessage}</label>
          <div className={css.showSetDefaultWeight}>
            <input
              className={css.secondInput}
              id="defaultWeight"
              type="number"
              name="defaultWeight"
              value={defaultWeightValues?.weight}
              onChange={handleWeightChange}
            />
            <select
              id="massUnit"
              name="massUnit"
              defaultValue={defaultWeightValues?.massUnit || 'oz'}
              onChange={handleUnitChange}
            >
              <option value="" disabled></option>
              {weightOptions.map(item => (
                <option key={item.key} value={item.key}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
          <div className={css.saveButton}>
            <Button
              inProgress={saveWeightInProgress}
              type="button"
              onClick={() => onSaveDefaultToAllListings(defaultWeightValues)}
              disabled={defaultWeightValues?.weight <= 0}
            >
              {saveButtonText}
            </Button>
          </div>
        </>
      )}
      <p>{orText}</p>
      <p>
        {updateManuallyText}{' '}
        <NamedLink className={css.hereText} name="ManageListingsPage">
          {hereLinkText}
        </NamedLink>
      </p>
    </div>
  );
};

// Memoize the component to avoid unnecessary re-renders
export default memo(TutulistOptionBlock);
